 /***********************************************/
 /**** OPEN CUSTOM COLLAPSIBLE ONE AT A TIME ****/
/***********************************************/
/**
 *  @class
 *  @function OpenOneCollapsibleRow
 */
class OpenOneCollapsibleRow {
    constructor() {
        this.collapsible = document.querySelector('.collapsible-content-custom');
        if(!this.collapsible) return;    
        this.collapsible.addEventListener('click', (evt) => {
            this.collapsible.querySelector('details[open]').removeAttribute('open');
            let rows = Array.from(evt.target.closest('.collapsible-content__inner').querySelectorAll('collapsible-row'));
            rows.forEach(row => {
                let details = row.querySelector('details');
                details.removeAttribute('open');
            });
        });
    }
}
window.addEventListener('load', (event) => {
    if(document.querySelectorAll('.collapsible-content-custom')[0]) {
        if (typeof OpenOneCollapsibleRow !== 'undefined') {
        new OpenOneCollapsibleRow();
        }
    }
});